import * as Yup from "yup";

const DivisionCreationSchema = Yup.object({
  name: Yup.string().required("name is required"),
});
export default DivisionCreationSchema;
